module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "id": "contents"
    }
  })]), _c('a', {
    attrs: {
      "id": "contents"
    }
  }, [_c('h1', [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  })]), _c('p', {
    staticClass: "tocitem1"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/07_chap1"
    }
  }, [_vm._v("CHAPTER 1 INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_chap1#c1a"
    }
  }, [_vm._v("How to Learn to Toss Dice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_chap1#c1b"
    }
  }, [_vm._v("Casino Attitude Toward Dice Control")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_chap1#c1c"
    }
  }, [_vm._v("The Rest of This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2"
    }
  }, [_vm._v("CHAPTER 2 THE RULES OF CRAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2#c2a"
    }
  }, [_vm._v("“Right” Bets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2#c2b"
    }
  }, [_vm._v("“Wrong” Bets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2#c2c"
    }
  }, [_vm._v("Field")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2#c2d"
    }
  }, [_vm._v("Propositions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_chap2#c2e"
    }
  }, [_vm._v("Crapless Craps")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3 CRAPS IN A CASINO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atmosphere")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layout")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pyramids")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speed of the Game")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Errors by Dice Dealers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playing Craps With Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protect Your Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing a Platform Is OK")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toking Dealers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap3#c3l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Player’s Card")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4 TOSSING DICE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grip")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alignment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delivery")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tossing Dice: Checklist")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Fingers or Three?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become Sensitive to Dice Action")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dialing In")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fatigue & Injury")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap4#c4i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flying Under the Radar")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 PRACTICE TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding Bed Tosses")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stop Dice on Axis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keep Rotational Axes Horizontal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distance and Accuracy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Practice When Tired")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap5#c5g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Practice Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 CHOOSING A DICE SET")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Studying Careful Shooters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Correlation Between Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Axis Control is Rare")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Start With Hardways Set")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Estimating Your SRR")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excess Double Pitches")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Sevens")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PD Ratio")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are You Good Enough?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Albuquerque Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap6#c6k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Have Axis Control")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 MONEY MANAGEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determining Your Bankroll")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Estimating Your Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Exposure")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Optimal Bet Size")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bets On Come-Out Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bets During Point Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressing Bets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Risk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signature Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If Strangers Bet Your Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If Skillful Shooter Is a Stranger")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Betting on a Random Roller")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7m",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EV Cost of Various Bad Bets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap7#c7n",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Estimating Win Per Hour")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 THE DICE CHALLENGE OF 2004")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Tamburin Piques My Interest")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Search for Dice Nuggets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Results, Small Sample Size")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How I Learned to Toss Dice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My First Casino Tosses")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Challenge Proposal")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volunteer Monitors Solicited")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pre-Challenge Comments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm-Up Session")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Ear Full of Cider")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volunteer Shooter: Little Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Details of the Challenge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap8#c8m",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Result: 74 Sevens in 500 Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 LITTLE JOE’S SKILL TEST")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Test Results")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Impressions of Test Results")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Follow-up From Little Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis of Test Results")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Joe Returns Home")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap9#c9f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons Learned From Little Joe’s Skill Test")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 FRONT-LINE OBSERVATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York Writer Flies to Las Vegas for a Dice Story")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casino Reaction to Dice Setters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dealers Can Be Good Guys")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time to Go")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tip Tease")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Dice at Golden Gate")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backed Off by Proxy?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Saw the Fire Bet Hit")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation of a Past Posting")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10j",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tip From a Big Bettor")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10k",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strangers Stand Out in Albuquerque")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10l",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ring Toss Stops a Game")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap10#c10m",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People Make Such Stupid Bets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 FINDING ALL SRRS FROM ANY SET")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap11#c11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Hardways")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap11#c11b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Sevens")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap11#c11c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting 3-V")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap11#c11d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sample Size and Precision")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 MINIMAL DICE SETTING")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap12#c12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Possible Dice Sets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap12#c12b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faces Delivered by Stick People")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap12#c12c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixing Dice Sets")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 THE MATH OF CRAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dice Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dice Rotation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13c",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permutations of Two Dice")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13d",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Precise Casino Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rolls per Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13f",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frequencies of Other Outcomes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13g",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Distribution of Hand Length")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap13#c13h",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hand Length for Skilled Shooters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_contact",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTACT INFORMATION")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355d9dfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_contents.vue
// module id = 66
// module chunks = 0